import React from 'react';
import { Box, Chip, CircularProgress, Tooltip } from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { QuickAction } from './types';

interface QuickActionsBarProps {
  quickActions: QuickAction[];
  isProcessing: boolean;
  activeActionLabel?: string | null;
  onActionClick: (action: QuickAction) => void;
}

export const QuickActionsBar: React.FC<QuickActionsBarProps> = ({
  quickActions,
  isProcessing,
  activeActionLabel,
  onActionClick,
}) => {
  if (!quickActions || quickActions.length === 0) {
    return null;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: 0.5,
        py: 0.25,
        px: 0.25,
        maxWidth: '100%',
      }}
    >
      <Tooltip title="Context Quick Actions">
        <AutoAwesomeIcon sx={{ fontSize: 13, color: '#f59e0b', flexShrink: 0, mr: 0.25 }} />
      </Tooltip>
      {quickActions.map((action, idx) => {
        const isActive = isProcessing && activeActionLabel === action.label;
        return (
          <Chip
            key={idx}
            icon={
              isActive ? (
                <CircularProgress size={11} thickness={5} sx={{ color: '#2563eb' }} />
              ) : (
                action.icon
              )
            }
            label={action.label}
            size="small"
            onClick={() => onActionClick(action)}
            disabled={isProcessing && !isActive}
            clickable={!isProcessing}
            variant={isActive ? 'filled' : 'outlined'}
            sx={{
              height: 22,
              fontSize: '0.68rem',
              fontWeight: 600,
              bgcolor: isActive ? '#eff6ff' : '#ffffff',
              borderColor: isActive ? '#3b82f6' : '#cbd5e1',
              color: isActive ? '#1d4ed8' : '#334155',
              cursor: isProcessing ? 'default' : 'pointer',
              boxShadow: isActive ? '0 0 0 1.5px rgba(59, 130, 246, 0.3)' : '0 1px 2px rgba(0,0,0,0.03)',
              transition: 'all 0.15s ease-in-out',
              '&:hover': !isProcessing
                ? {
                    bgcolor: '#eff6ff',
                    borderColor: '#3b82f6',
                    color: '#1d4ed8',
                  }
                : {},
              '& .MuiChip-icon': {
                fontSize: 13,
              },
              '& .MuiChip-label': {
                px: 0.75,
              },
            }}
          />
        );
      })}
    </Box>
  );
};
